import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "../../scss/GettingStartedForm.scss";
import { forwardRef, useEffect, useState } from "react";
import GooglePlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
    geocodeByPlaceId,
} from "react-google-places-autocomplete";
import { authConstants } from "../../redux/action-constants/onboarding.constants";
import { MultiSelect } from "react-multi-select-component";
import { appConstants } from "../../redux/action-constants/inapp.constants";
import { LoadingItem } from "../../shared/components/loading";
import { AlertMsg } from "../../shared/components/alert-msg";


const getStoreUrlAction = async ({ pageProps, payload }: any) => {

    await pageProps.getStoreUrlAction(payload);
}

const getStoreCategoryOptions = async ({ pageProps, payload }: any) => {

    await pageProps.getStoreCategoriesAction(payload);
}

const handleSignup = async ({ pageProps, payload, storeLogo }: any) => {

    await pageProps.createAccountAction(payload, storeLogo)
}

const handleresendActivation = async ({ pageProps, payload }: any) => {

    await pageProps.resendActivationEmailAction(payload);
}


const GettingStartedForm = forwardRef<HTMLDivElement, any>(({ pageProps }, ref) => {
    const [isloadingStoreUrl, setIsloadingStoreUrl] = useState<boolean>(false)
    const [selectedStoreUrl, setSelectedStoreUrl] = useState<string | null>("")
    const [isStoreUrlOpen, setIsStoreUrlOpen] = useState<boolean>(false);
    const [userEmail, setUserEmail] = useState<string>("")
    const [categoryOptions, setCategoryOptions] = useState<
        Array<{ value: string; label: string }>
    >([]);
    const [extractedInfo, setExtractedInfo] = useState<any>();
    const [ownerExtractedInfo, setOwnerExtractedInfo] = useState<any>();

    const [addressSearched, setAddressSearched] = useState<any>();
    const [addressLatLng, setAddressLatLng] = useState<any>();
    const initialValues = {
        storeName: "",
        category: [],
        fullName: "",
        address: "",
        email: "",
        phone: "",
        password: "",
    };

    const validationSchema = Yup.object({
        storeName: Yup.string().required("Store name is required"),
        category: Yup.array()
            .of(Yup.object().shape({
                label: Yup.string().required(),
                value: Yup.string().required(),
            }))
            .min(1, "Please select at least one category"),
        fullName: Yup
            .string()
            .required("Full name is required")
            .matches(
                /^[A-Za-z]+ [A-Za-z]+$/,
                "Full name must be exactly two names (e.g., John Doe)"
            ),
        address: Yup.string().required("Store address is required"),
        email: Yup.string().email("Invalid email").required("Email is required"),
        phone: Yup.string()
            .matches(/^[0-9]{10,15}$/, "Enter a valid phone number")
            .required("Phone number is required"),
        password: Yup.string()
            .min(6, "Password must be at least 6 characters")
            .required("Password is required"),
    });
    let extractedData: any = {};

    const handleSelectedAddress = async (address: any) => {
        setAddressSearched(address);



        const [place] = await geocodeByPlaceId(address?.value.place_id);
        let addressMeta = place?.address_components;




        geocodeByAddress(address?.label)
            .then((results) => getLatLng(results[0]))
            .then(({ lat, lng }: any) => {


                setAddressLatLng({ lat, lng });
            });

        let extractedInfoFromAddress = () => {
            let streetNumber: any = "",
                streetName: any = "",
                areaName: any = "",
                townName: any = "",
                postalCodeArea: any = "",
                fullAddress: any,
                topLevelArea: any,
                provinceChosenFull: any,
                provinceChosen: any;

            for (
                let componentIndex = 0;
                componentIndex < addressMeta.length;
                componentIndex++
            ) {
                if (
                    addressMeta[componentIndex]?.types.length === 1 &&
                    addressMeta[componentIndex]?.types[0] === "postal_code" &&
                    !extractedData?.postCode
                ) {
                    extractedData.postCode = addressMeta[componentIndex]?.long_name;
                }

                if (
                    addressMeta[componentIndex]?.types.length === 1 &&
                    addressMeta[componentIndex]?.types[0] === "street_number" &&
                    streetNumber === ""
                ) {
                    streetNumber = `${addressMeta[componentIndex]?.long_name}`;
                }

                if (
                    addressMeta[componentIndex]?.types.length === 1 &&
                    addressMeta[componentIndex]?.types[0] === "route" &&
                    streetName === ""
                ) {
                    streetName = `${streetNumber !== "" ? ", " : ""}${addressMeta[componentIndex]?.long_name
                        }`;
                }

                if (
                    addressMeta[componentIndex]?.types.length >= 1 &&
                    (addressMeta[componentIndex]?.types.includes("neighborhood") ||
                        addressMeta[componentIndex]?.types.includes("locality")) &&
                    areaName.split(",").length - 1 < 1

                    // && areaName === ""
                ) {
                    areaName += `${streetNumber !== "" || streetName !== "" || areaName !== ""
                        ? ", "
                        : ""
                        }${addressMeta[componentIndex]?.long_name}`;
                }

                if (
                    addressMeta[componentIndex]?.types.length >= 2 &&
                    addressMeta[componentIndex]?.types.includes(
                        "administrative_area_level_5"
                    ) &&
                    areaName.split(",").length - 1 < 1
                ) {
                    areaName += `${streetNumber !== "" || streetName !== "" || areaName !== ""
                        ? ", "
                        : ""
                        }${addressMeta[componentIndex]?.long_name}`;
                }

                if (
                    addressMeta[componentIndex]?.types.length >= 2 &&
                    addressMeta[componentIndex]?.types.includes(
                        "administrative_area_level_4"
                    ) &&
                    areaName.split(",").length - 1 < 1
                ) {
                    areaName += `${streetNumber !== "" || streetName !== "" || areaName !== ""
                        ? ", "
                        : ""
                        }${addressMeta[componentIndex]?.long_name}`;
                }

                if (
                    addressMeta[componentIndex]?.types.length >= 2 &&
                    addressMeta[componentIndex]?.types.includes(
                        "administrative_area_level_3"
                    )
                    // && areaName === ""
                ) {
                    townName += `${streetNumber !== "" || streetName !== "" || areaName !== ""
                        ? ", "
                        : ""
                        }${addressMeta[componentIndex]?.long_name}`;
                }

                if (
                    addressMeta[componentIndex]?.types.length >= 2 &&
                    addressMeta[componentIndex]?.types.includes(
                        "administrative_area_level_2"
                    )
                    // && areaName === ""
                ) {
                    townName += `${streetNumber !== "" || streetName !== "" || areaName !== ""
                        ? ", "
                        : ""
                        }${addressMeta[componentIndex]?.long_name}`;
                }



                if (
                    addressMeta[componentIndex]?.types.length >= 2 &&
                    (addressMeta[componentIndex]?.types.includes(
                        "administrative_area_level_3"
                    ) ||
                        addressMeta[componentIndex]?.types.includes(
                            "administrative_area_level_4"
                        ) ||
                        addressMeta[componentIndex]?.types.includes(
                            "administrative_area_level_5"
                        ) ||
                        addressMeta[componentIndex]?.types.includes("locality") ||
                        addressMeta[componentIndex]?.types.includes(
                            "administrative_area_level_2"
                        ))
                    // && postalCodeArea.length === 0
                    // && areaName === ""
                ) {
                    postalCodeArea = `${addressMeta[componentIndex]?.long_name}`;
                }

                if (
                    addressMeta[componentIndex]?.types.length >= 2 &&
                    // addressMeta[componentIndex]?.types.includes("administrative_area_level_2") ||
                    addressMeta[componentIndex]?.types.includes(
                        "administrative_area_level_1"
                    ) &&
                    postalCodeArea.split(",").length - 1 < 1
                ) {
                    postalCodeArea += `${postalCodeArea !== "" ? ", " : ""}${addressMeta[componentIndex]?.short_name
                        }`;
                    topLevelArea = addressMeta[componentIndex]?.long_name;
                }
                if (
                    addressMeta[componentIndex]?.types.length >= 2 &&
                    // addressMeta[componentIndex]?.types.includes("administrative_area_level_2") ||
                    addressMeta[componentIndex]?.types.includes(
                        "administrative_area_level_1"
                    )
                ) {
                    provinceChosen = addressMeta[componentIndex]?.short_name;
                    provinceChosenFull = addressMeta[componentIndex]?.long_name;
                }

                // fullAddress = `${streetNumber} ${streetName} ${areaName} ${townName}`;
                fullAddress = `${streetNumber} ${streetName} ${areaName}`;
                extractedData.newAddress = fullAddress;
                extractedData.postalCodeArea = postalCodeArea;
                extractedData.topLevelArea = topLevelArea;
                extractedData.provinceChosen = provinceChosen;
                extractedData.provinceChosenFull = provinceChosenFull;

                if (
                    extractedData?.postCode &&
                    extractedData?.newAddress &&
                    extractedData?.provinceChosen &&
                    extractedData?.provinceChosenFull
                ) {
                    break;
                }
            }



            return extractedData;
        };
        setExtractedInfo(extractedInfoFromAddress());
        setOwnerExtractedInfo(extractedInfoFromAddress())
    };
    useEffect(() => {
        getStoreUrlAction({
            pageProps,
            payload: "CLEAR"
        })
        getStoreCategoryOptions({
            pageProps,
            payload: "Page1&Size=1000"
        })
        handleSignup({
            pageProps,
            payload: "CLEAR"
        })
        handleresendActivation({
            pageProps,
            payload: "CLEAR",
        })
    }, [])

    useEffect(() => {
        if (pageProps?.getUrlRequest?.request_status === authConstants.GET_URL_OPTIONS_PENDING) {
            setIsloadingStoreUrl(true)
        }
        else {
            setIsloadingStoreUrl(false)
        }
    }, [pageProps?.getUrlRequest?.request_status])

    useEffect(() => {
        if (pageProps?.getStoreCatsRequest?.request_status === authConstants.GET_STORE_CATS_SUCCESS) {
            const allCategories = pageProps?.getStoreCatsRequest?.request_data?.response?.results?.map(
                (element: { name: string }) => {
                    return {
                        value: element?.name,
                        label: element?.name,
                    };
                }
            );
            setCategoryOptions(allCategories)
        }
    }, [pageProps?.getStoreCatsRequest?.request_status])

    const handleSubmit = (values: typeof initialValues) => {
        const categories = values.category.map((c: any) => c.value);
        const payloadData = {
            email: values.email,
            password: values.password,
            storeModel: {
                name: values.storeName,
                url: selectedStoreUrl,
                phoneNumber: values.phone,
                address: {
                    city: extractedInfo?.provinceChosenFull,
                    postalCode: extractedInfo?.postCode,
                    streetAddress: extractedInfo?.newAddress,
                    country: "Canada",
                    countryId: 0,
                },
                email: values.email,
                tags: categories,
                longitude: addressLatLng.lng,
                latitude: addressLatLng.lat,
            },
            userProfileModel: {
                firstName: values.fullName.split(" ")[0] || "",
                lastName: values.fullName.split(" ")[1] || "",
                phoneNumber: values.phone,
                postalCode: ownerExtractedInfo?.postCode,
                streetAddress: ownerExtractedInfo?.newAddress,
                city: ownerExtractedInfo?.provinceChosenFull,
                country: "Canada",
                howDidYouHearAboutUs: "",
            }
        }
        handleSignup({ pageProps: pageProps, payload: payloadData, storeLogo: null })
    };

    return (
        <div className="getting-started-form" ref={ref} tabIndex={-1}>
            {pageProps?.creatUserRequest?.request_status === authConstants.CREATE_ACCOUNT_SUCCESS ? (
                <div className="email-verfication-wrap">
                    <h3>You’re almost there</h3>
                    <p>Check your email and click on the verification link to complete your account setup</p>
                    <div className="error-wrap">
                        {pageProps?.resendActivationEmailRequest?.request_status === authConstants.RESEND_ACTIVATION_EMAIL_FAILURE &&
                            <AlertMsg type="error" message={pageProps?.resendActivationEmailRequest?.request_data.error || "An Error Occured"} />
                        }
                        {pageProps?.resendActivationEmailRequest?.request_status === authConstants.RESEND_ACTIVATION_EMAIL_SUCCESS &&
                            <AlertMsg type="success" message="Activation email has been resent to you" />
                        }
                    </div>
                    {pageProps?.resendActivationEmailRequest?.request_status === authConstants.RESEND_ACTIVATION_EMAIL_PENDING &&
                        <div>
                            <LoadingItem />
                        </div>}
                    <button
                        disabled={pageProps?.resendActivationEmailRequest?.request_status === authConstants.RESEND_ACTIVATION_EMAIL_PENDING}
                        onClick={async () => {
                            await handleresendActivation({ pageProps, payload: `${userEmail}` })
                        }}>
                        Resend Email Activation Link
                    </button>

                </div>
            ) : (
                <>
                    <div className="text-content">
                        <h2>Easy setup in just three simple steps!</h2>

                        <p>
                            Start Selling Online for FREE in 5 Minutes. No Fees. No Commissions.
                            Instant Payouts
                        </p>
                    </div>
                    {pageProps?.creatUserRequest?.request_status !== authConstants.CREATE_ACCOUNT_PENDING ? (

                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                        >
                            {() => (
                                <Form className="form-grid" autoComplete="off">
                                    {/* Store name + category */}
                                    <div className="input-group">
                                        <Field name="storeName" placeholder="Enter your store name" autoComplete="off"
                                            onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                                                if (!isloadingStoreUrl) {
                                                    if (e.target.value.length !== 0) {
                                                        getStoreUrlAction({ pageProps: pageProps, payload: e.target.value });
                                                    } else {
                                                        getStoreUrlAction({
                                                            pageProps,
                                                            payload: "CLEAR"
                                                        })
                                                    }
                                                    setIsStoreUrlOpen(true)
                                                }
                                            }}
                                        />
                                        <ErrorMessage name="storeName" component="span" className="error" />
                                    </div>
                                    <div>
                                        <Field name="category">
                                            {({ form }: any) => (
                                                <MultiSelect
                                                    hasSelectAll={false}
                                                    options={categoryOptions}
                                                    value={form.values.category}
                                                    onChange={(selected: any) => {
                                                        form.setFieldValue("category", selected);
                                                        form.setFieldTouched("category", true, false);
                                                    }}
                                                    labelledBy="Select Categories"
                                                    className={`biz-cat ${form.errors.category
                                                        ? "invalid-input-wrap"
                                                        : ""
                                                        }`}
                                                    overrideStrings={{
                                                        search: "Select Categories",
                                                        selectSomeItems: "Select Categories",
                                                        allItemsAreSelected: "All categories are chosen.",
                                                        noOptions: "No categories match",
                                                    }}
                                                />
                                            )}
                                        </Field>

                                        <ErrorMessage name="category" component="span" className="error" />
                                    </div>

                                    {/* Link */}
                                    {pageProps?.getUrlRequest?.request_status === authConstants.GET_URL_OPTIONS_SUCCESS ?
                                        (
                                            <div className="store-list full">
                                                    {pageProps?.getUrlRequest?.request_data?.response?.length !== 0 &&
                                                        pageProps?.getUrlRequest?.request_data?.response
                                                            ?.filter((storeUrl: string) => !selectedStoreUrl || selectedStoreUrl === storeUrl)
                                                            .map((storeUrl: string, idx: number) => (
                                                                <label key={idx} className="store-item">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedStoreUrl === storeUrl}
                                                                        onChange={() => {
                                                                            setSelectedStoreUrl(
                                                                                selectedStoreUrl === storeUrl ? null : storeUrl
                                                                            );
                                                                            setIsStoreUrlOpen(false);
                                                                        }}
                                                                    />
                                                                    <span className="custom-checkbox"></span>
                                                                    <span className="store-url-link">{storeUrl}</span>
                                                                </label>
                                                            ))
                                                    }
                                            </div>
                                        ) : (
                                            pageProps?.getUrlRequest?.request_status === authConstants.GET_URL_OPTIONS_FAILURE ? (
                                                <a href="#" className="link-error " >
                                                    {pageProps?.getUrlRequest?.request_status === authConstants.GET_URL_OPTIONS_PENDING ? <LoadingItem /> : pageProps?.getUrlRequest?.request_data?.error}
                                                </a>
                                            ) :
                                                (<a href={window.location.origin !== "https://vendor.mamimarkets.com"
                                                    ? "https://staging.mamimarkets.com/"
                                                    : "http://mamimarkets.com"} className="link" >
                                                    {pageProps?.getUrlRequest?.request_status === authConstants.GET_URL_OPTIONS_PENDING ? <LoadingItem /> : window.location.origin !== "https://vendor.mamimarkets.com"
                                                        ? "https://staging.mamimarkets.com/"
                                                        : "http://mamimarkets.com"}
                                                </a>)
                                        )}

                                    {/* Full name */}
                                    <div className="input-group full">
                                        <Field name="fullName" placeholder="Full name" autoComplete="off" />
                                        <ErrorMessage name="fullName" component="span" className="error" />
                                    </div>

                                    {/* Address with icon */}
                                    <div className="full">
                                        <Field name="address">
                                            {({ field, form, meta }: any) => (
                                                <div >
                                                    {/* Icon */}
                                                    <span className="icon">
                                                        <i className="fas fa-map-marker-alt"></i>
                                                    </span>

                                                    <GooglePlacesAutocomplete
                                                        apiKey={appConstants.GOOGLE_MAP_KEY}
                                                        autocompletionRequest={{
                                                            componentRestrictions: {
                                                                country: ["ca"],
                                                            },
                                                        }}
                                                        selectProps={{
                                                            value: field.value ? { label: field.value, value: field.value } : null,
                                                            onChange: (address: any) => {
                                                                handleSelectedAddress(address);
                                                                form.setFieldValue(field.name, address?.label || "");
                                                                form.setFieldError(field.name, "");
                                                            },
                                                            onBlur: () => {
                                                                form.setFieldTouched(field.name, true);
                                                            },
                                                            placeholder: "Store address",
                                                            className: `address-search auto ${meta.touched && meta.error
                                                                ? "is-invalid-input"
                                                                : !meta.error && field.value !== ""
                                                                    ? "valid-input"
                                                                    : ""
                                                                }`,
                                                            openMenuOnClick: false,
                                                            noOptionsMessage: () => "Type a valid address",
                                                            styles: {
                                                                control: (provided: any) => ({
                                                                    ...provided,
                                                                    minHeight: "44px",
                                                                    border: "none",
                                                                    boxShadow: "none",
                                                                    cursor: "text",
                                                                    backgroundColor: "#F4F4F4",
                                                                }),
                                                                input: (provided: any) => ({
                                                                    ...provided,
                                                                    fontSize: "13px",
                                                                    color: "#333",
                                                                    cursor: "text"
                                                                }),
                                                                menu: (provided: any) => ({
                                                                    ...provided,
                                                                    backgroundColor: "#F4F4F4",
                                                                    zIndex: 9999,
                                                                }),
                                                                option: (provided: any, state: any) => ({
                                                                    ...provided,
                                                                    backgroundColor: state.isFocused ? "#e6f0ff" : "#fff",
                                                                    color: "#000",
                                                                    padding: "10px",
                                                                    cursor: "pointer",
                                                                }),
                                                            },
                                                            components: {
                                                                DropdownIndicator: () => null,
                                                                IndicatorSeparator: () => null,
                                                            },
                                                        }}
                                                    />
                                                    {/* Error message */}
                                                    {meta.touched && meta.error && (
                                                        <p className="error">{meta.error}</p>
                                                    )}
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    {/* Email + Phone */}
                                    <div className="input-group">
                                        <Field name="email" placeholder="Email" autoComplete="off"
                                            onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                                                setUserEmail(e.target.value)
                                            }} />
                                        <ErrorMessage name="email" component="span" className="error" />
                                    </div>

                                    <div className="input-group">
                                        <Field name="phone" placeholder="Phone number" autoComplete="off" />
                                        <ErrorMessage name="phone" component="span" className="error" />
                                    </div>

                                    {/* Password */}
                                    <div className="input-group full">
                                        <Field
                                            name="password"
                                            type="password"
                                            autoComplete="off"
                                            placeholder="Password"
                                        />
                                        <ErrorMessage name="password" component="span" className="error" />
                                    </div>

                                    {/* Terms */}
                                    <p className="terms full">
                                        By proceeding, you agree to the{" "}
                                        <a href="https://www.mamimarkets.com/terms" >Terms of Service</a> and{" "}
                                        <a href="https://www.mamimarkets.com/privacy-policy">Privacy Policy</a>
                                    </p>
                                    <div>
                                        {pageProps?.creatUserRequest?.request_status === authConstants.CREATE_ACCOUNT_FAILURE &&
                                            <AlertMsg type="error" message={pageProps.creatUserRequest?.request_data.error} />
                                        }
                                    </div>
                                    <div className="button-wrap">
                                        {/* Submit button */}
                                        <button type="submit" className="submit-btn" disabled={isloadingStoreUrl || !selectedStoreUrl || userEmail.length === 0}>
                                            Start for free
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>) : (
                        <LoadingItem />
                    )}
                </>)}
        </div>
    );
});

export default GettingStartedForm